import React from 'react';
import { connect } from 'react-redux';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { useInternalNavigate } from '../../../utils/navigate/useNavigate';
import { useDispatch } from 'react-redux';
import { setSelectedChildIndex } from '../../../redux/slices/quoteDataSlice';
import { formatDateToString } from '../../../utils/dateUtils/dateUtils';

const HorizontalCard = ({ fields, prospectDetails }) => {
  const dispatch = useDispatch();
  const navigate = useInternalNavigate();
  const memberType = fields.memberType?.value;
  const index = fields.childIndex?.value || 0;
  const genders = { M: fields.male?.value, F: fields.female?.value };

  let tag = '';
  let title = '';
  let body = '';

  if (memberType === 'primary') {
    if (!prospectDetails.forename || !prospectDetails.surname) {
      return null;
    }
    tag = 'PRIMARY';
    title = `${prospectDetails.forename} ${prospectDetails.surname}`;
    body = prospectDetails.gender
      ? `${formatDateToString(new Date(prospectDetails.dateOfBirth))} |
      ${genders[prospectDetails.gender]}`
      : `${formatDateToString(new Date(prospectDetails.dateOfBirth))}`;
  }

  if (memberType === 'partner') {
    if (!prospectDetails.dependents.spouse) {
      return null;
    }
    const spouse = prospectDetails.dependents.spouse;
    if (!spouse || !spouse.dateOfBirth) {
      return null;
    }
    tag = 'PARTNER';
    title = spouse.forename && spouse.surname ? `${spouse.forename} ${spouse.surname}` : 'Partner';
    body = spouse.gender
      ? `${formatDateToString(new Date(spouse.dateOfBirth))} | ${genders[spouse.gender]}`
      : `${formatDateToString(new Date(spouse.dateOfBirth))}`;
  }

  if (memberType === 'child') {
    if (!prospectDetails.dependents.children) {
      return null;
    }
    const child = prospectDetails.dependents.children[index];
    if (!child || !child.dateOfBirth) {
      return null;
    }
    tag = 'DEPENDANT';
    title =
      child.forename && child.surname ? `${child.forename} ${child.surname}` : `Child ${index + 1}`;
    body = child.gender
      ? `${formatDateToString(new Date(child.dateOfBirth))} | ${genders[child.gender]}`
      : `${formatDateToString(new Date(child.dateOfBirth))}`;
  }

  const handleEdit = () => {
    if (memberType === 'child' && prospectDetails.dependents.children.length === 1) {
      navigate('/child-details/');
    } else if (memberType === 'child') {
      dispatch(setSelectedChildIndex(index));
      navigate('/children-details/');
    } else if (memberType === 'partner') {
      navigate('/partner-details/');
    } else if (memberType === 'primary') {
      navigate('/your-details/');
    } else {
      return;
    }
  };

  return (
    <div className="vds-grid__column vds-grid__column--sm-6">
      <div className="vds-horizontal-card vds-horizontal-card--uncontained">
        <div className="vds-horizontal-card__inner">
          <div id="vds-horizontal-card-content" className="vds-horizontal-card__content">
            <span className="vds-horizontal-card__tag">{tag}</span>
            <h2 className="vds-horizontal-card__heading">{title}</h2>
            <div className="vds-horizontal-card__body">
              <p>{body}</p>
            </div>
            <div className="vds-horizontal-card__action">
              <a href="#" onClick={handleEdit} data-testid={`${fields.testid?.value}-memberType`}>
                {fields.linkText?.value}
              </a>
            </div>
          </div>
          <div className="vds-horizontal-card__image-container">
            <Image
              className="vds-horizontal-card__image"
              field={fields.image}
              data-testid={`${fields.testid?.value}-image`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  prospectDetails: state.quoteData.prospectDetails,
});

export default connect(mapStateToProps)(HorizontalCard);
